<template>
  <div>
    <b-card
      title="Engineers Page"
      body-class="text-center"
    >
      <PersonnelNavitem
        :technical-reg="TechnicalReg"
        @tab-selected="setActiveTab"
      />

      <b-card-body class="p-0">
        <div>
          <div>
            <PersonnelUserInfo
              v-if="filteredAnyData.length"
              :filtered-user-data="filteredAnyData[0]"
            />
          </div>

          <div
            v-if="filteredUserData.length"
            class="text-left my-2"
          >
            <UserPerTable
              :entry-data="filteredUserData[0]"
            />
          </div>
          <b-row>
            <b-col
              cols="12"
              md="3"
            >
              <b-table
                v-if="filteredUserData.length"
                :items="uniqueStatusList"
                :fields=" [{ key: 'status', label: 'Status List' }]"
                bordered
                fixed
                head-variant="dark"
                class="text-wrap-in-table"
              />
            </b-col>
            <b-col
              cols="12"
              md="9"
            >
              <UserPerTable
                v-if="filteredUserData.length > 1"
                :entry-data="filteredUserData.slice(1)"
              />
            </b-col>
          </b-row>

        </div>
      </b-card-body>

    </b-card>
    <b-card
      title="Open Evaluation"
    >
      <b-row>
        <b-col
          cols="12"
          md="4"
        />
        <b-col
          cols="12"
          md="8"
        >
          <PersonnelOpenTable
            v-if="filteredOpenData.length"
            :user-open-data="filteredOpenData"
            :ex-evaluation-date="expectedDate"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          md="8"
        >
          <PersonnelAuditAndtrainigTables
            v-if="filteredOpenData.length"
            :open-evaluation-id="filteredOpenData[0].id"
            :request-evaluation-id="filteredOpenData[0].certificate_category_id"
          />
        </b-col>
      </b-row>
      <PersonnelEvaluationFiles
        v-if="filteredOpenData.length"
        :evaluation-id="filteredOpenData[0].id"
        :evaluation="filteredOpenData[0]"
      />

      <SubmitEvaluation
        v-if="filteredOpenData.length"
        :evaluation-id="filteredOpenData[0].id"
        :evaluation-data="filteredOpenData[0]"
      />
    </b-card>
  </div>
</template>

<script>
import axios from 'axios'
import decryptData from '@/store/auth/decryptData'
import UserPerTable from '../personnel-components/PersonnelUserPerTable.vue'
import PersonnelUserInfo from '../personnel-components/PersonnelUserInfo.vue'
import PersonnelOpenTable from '../personnel-components/PersonnelOpenTable.vue'
import PersonnelAuditAndtrainigTables from '../personnel-components/PersonnelAuditAndtrainigTables.vue'
import PersonnelNavitem from '../personnel-components/PersonnelNavitem.vue'
import SubmitEvaluation from '../personnel-action/SubmitEvaluation.vue'
import PersonnelEvaluationFiles from '../personnel-components/PersonnelEvaluationFiles.vue'

export default {
  name: 'PersonnelUser',
  components: {
    UserPerTable, PersonnelUserInfo, PersonnelOpenTable, PersonnelAuditAndtrainigTables, PersonnelNavitem, SubmitEvaluation, PersonnelEvaluationFiles,
  },
  data() {
    return {
      TechnicalReg: [],
      userPersonnelData: [],
      userOpenData: [],
      activeTab: null,
    }
  },
  computed: {
    expectedDate() {
      return this.filteredUserData.length ? this.filteredUserData[0].next_evaluation_date || '' : ''
    },
    filteredUserData() {
      return this.userPersonnelData.filter(
        item => item.certificate_category_id === this.activeTab,
      )
    },
    filteredOpenData() {
      return this.userOpenData.filter(
        item => item.certificate_category_id === this.activeTab,
      )
    },
    filteredAnyData() {
      return [...this.filteredUserData, ...this.filteredOpenData]
    },
    uniqueStatusList() {
      const statuses = this.filteredUserData
        .map(item => item.ce_level_after)
        .filter(status => status && status.id) // ensure it exists

      // deduplicate by id
      const unique = []
      const seen = new Set()
      statuses.forEach(status => {
        if (!seen.has(status.id)) {
          seen.add(status.id)
          unique.push(status)
        }
      })
      return unique
    },
  },

  beforeMount() {
    this.getUserPersonnel()
  },

  methods: {
    getUserPersonnel() {
      axios.get(`personnel-evaluation?user_id=${this.$route.params.id}`).then(res => {
        const userPerData = decryptData(res.data.payload).data.data
        this.userPersonnelData = userPerData.filter(item => item.completed_at !== null)
        this.userOpenData = userPerData.filter(item => item.completed_at === null)
        this.TechnicalReg = [
          ...new Map(
            userPerData.map(item => [
              item.certificate_category.id,
              { name: item.certificate_category.name, id: item.certificate_category.id, active: false },
            ]),
          ).values(),
        ]
        this.setActiveTab(this.$route.params.ccId || this.TechnicalReg[0]?.id)
      })
    },
    setActiveTab(id) {
      this.activeTab = Number(id)
      this.TechnicalReg = this.TechnicalReg.map(item => ({
        ...item,
        active: item.id === Number(id),
      }))
    },
  },
}
</script>
